<div *ngIf="getMachine()">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button (click)="reload()" class="nav-link active" id="settings-tab" data-bs-toggle="tab" data-bs-target="#settings" type="button" role="tab" aria-controls="settings" aria-selected="true">
        {{'pages.tables.machine.settings' | translate}}
      </button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="getMachine().pipelines.length > 0">
      <button (click)="reload()" class="nav-link" id="batches-tab" data-bs-toggle="tab" data-bs-target="#batches" type="button" role="tab" aria-controls="batches" aria-selected="false">
        {{'pages.tables.machine.batches.batches' | translate}}
      </button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="getMachine().realtime.length > 0">
      <button (click)="reload()" class="nav-link" id="realtime-tab" data-bs-toggle="tab" data-bs-target="#realtime" type="button" role="tab" aria-controls="realtime" aria-selected="false">
        {{'pages.tables.machine.realtime' | translate}}
      </button>
    </li>
  </ul>

  <div class="tab-content" id="myTabContent">
    <!-- Settings Tab -->
    <div class="tab-pane fade show active p-3" id="settings" role="tabpanel" aria-labelledby="settings-tab">
      <machine-settings></machine-settings>
    </div>
    <!-- Batches Tab -->
    <div class="tab-pane fade p-3" id="batches" role="tabpanel" aria-labelledby="batches-tab">
      <machine-batches></machine-batches>
    </div>
    <!-- Realtime Tab -->
    <div class="tab-pane fade p-3" id="realtime" role="tabpanel" aria-labelledby="realtime-tab">
      <machine-realtime></machine-realtime>
    </div>
  </div>
</div>

<div *ngIf="!getMachine()">
  <h5>{{'pages.tables.machine.na' | translate}}</h5>
</div>
